import { RatingIcon } from "./ratingIcon";
import styles from "./styles.module.scss";

interface IRatingStarScoreProps {
  ratingScore: number;
}
export const RatingStarScore = ({ ratingScore }: IRatingStarScoreProps) => {
  return (
    <div className={styles["container"]}>
      <RatingIcon readonly initialValue={ratingScore} />
      <span className={styles["subtitle2"]}>{ratingScore.toFixed(2)}</span>
    </div>
  );
};
